import { hasOwn } from '../utils/dataHelpers';
export const REFRESH_REDUCER_AFTER_RECEIVING_GATES = 'REFRESH_REDUCER_AFTER_RECEIVING_GATES';
class ReducerDifferManager {
  constructor() {
    this.cache = {};
    this.reduxSliceToGateLookupMap = {};
    this.reducerTypeMap = {};
    this.gates = [];
  }
  setGates(gates) {
    this.gates = gates;
  }
  setStore(store) {
    this.store = store;
  }
  clear() {
    this.gates = [];
    this.cache = {};
  }
  getIsUngatedFor(gate, sliceKey) {
    const reducerType = sliceKey ? this.reducerTypeMap[sliceKey] : null;
    if (reducerType) return reducerType === 'immer';
    if (!gate) return false;
    if (hasOwn(this.cache, gate)) return this.cache[gate];
    const isUngated = this.gates.includes(gate);
    this.cache[gate] = isUngated;
    return isUngated;
  }
  addReduxSliceGateLookup(sliceKey, gate) {
    if (this.reduxSliceToGateLookupMap[sliceKey]) {
      console.error('Gate already set up for redux slice, this could lead to errors');
    }
    this.reduxSliceToGateLookupMap[sliceKey] = gate;
  }
  getGateForReduxSlice(sliceKey) {
    return this.reduxSliceToGateLookupMap[sliceKey];
  }
  getReduxSliceGateLookupMap() {
    return this.reduxSliceToGateLookupMap;
  }
  mergeToReduxSliceGateLookupMap(map) {
    Object.assign(this.reduxSliceToGateLookupMap, map);
  }
  setReducerType(sliceKey, type) {
    this.reducerTypeMap[sliceKey] = type;
  }
  getReducerTypeMap() {
    return this.reducerTypeMap;
  }
  mergeToReducerTypeMap(map) {
    Object.assign(this.reducerTypeMap, map);
  }
  refreshReducerStateAfterReceivingGates(reducerName) {
    if (!this.store) {
      console.error('Attempting to refresh the reducer state after receiving gates without first setting the store, aborting');
      return;
    }
    this.store.dispatch({
      type: REFRESH_REDUCER_AFTER_RECEIVING_GATES,
      reducerName
    });
  }
}

// This is workaround for custom inpage editor instances that may be part of it's own bundle.
// Each bundle will have it's own singleton reference, which is undesired. This will make it
// so every bundle on the page will share the same instance of the singleton.

const windowRef = window;
if (!windowRef.hubspot || !windowRef.hubspot.ReducerDifferManager) {
  const ReducerDifferManagerInstance = new ReducerDifferManager();
  if (!windowRef.hubspot) {
    windowRef.hubspot = {};
  }
  windowRef.hubspot.ReducerDifferManager = ReducerDifferManagerInstance;
}
export default windowRef.hubspot.ReducerDifferManager;